const AUTH_SERVER_URL = 'https://auth.documedias.com/';

// Production
const PLANNER_API_URL = 'https://euroelso2022.planner.documedias.systems/api';

// Development
// const PLANNER_API_URL = 'http://localhost:8000/api';

const PLANNER_API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjoxMDE3LCJjb25ncmVzc0lkIjoxMjk4LCJkYXRlIjoiMjAyMS0xMC0wOFQxMTozMjoyNC42MDlaIiwiaWF0IjoxNjMzNjkyNzQ0fQ.EEh4I-fCzKR9DkJ9KZ-Yg9uBy6LJGH93AhEI9nDbNGA';

const CONGRESS_ID = 1298;
const SUBMISSION_API_URL = 'https://euroelso2022.abstract.documedias.systems/api/v1/manager/abstract/multi/html/id/{{id}}/template/planner_preview';

const SESSION_GROUP_ID = 9;

export {
  PLANNER_API_URL,
  PLANNER_API_KEY,
  AUTH_SERVER_URL,
  CONGRESS_ID,
  SUBMISSION_API_URL,
  SESSION_GROUP_ID,
}